"use strict";
exports.frCH = void 0;
var _index = require("./fr/_lib/formatDistance.js");
var _index2 = require("./fr/_lib/localize.js");
var _index3 = require("./fr/_lib/match.js");

var _index4 = require("./fr-CH/_lib/formatLong.js");
var _index5 = require("./fr-CH/_lib/formatRelative.js"); // Same as fr
// Unique for fr-CH
/**
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */
const frCH = (exports.frCH = {
  code: "fr-CH",
  formatDistance: _index.formatDistance,
  formatLong: _index4.formatLong,
  formatRelative: _index5.formatRelative,
  localize: _index2.localize,
  match: _index3.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});
